"use strict";

import PageCommon from "./PageCommon.js";

import Globals from "../Globals.js";
import Pqp from "../3x1010/Pqp";

export default class PlayerManager extends PageCommon {
    constructor() {
        super();
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("PlayerManager - constructor");

        this.tracks = null;
        this.userManager = null;
        this.playlists = [];
        this.artists = null;
        this.albums = null;

        this.track = null;
        this.trackElement = null;
        this.player = null;
        this.mobilePlayer = null;
        this.playingInterval = null;
        this.initialized = false;
        this.mouseMoving = false;
        this.autoload = false;
    }
    init({ tracks, userManager, playlists, artists, albums }) {
        super.init();
        this.tracks = tracks;
        this.userManager = userManager;
        this.playlists = playlists;
        this.artists = artists;
        this.albums = albums;
        this.trackEnded = false;
        const _this = this;
        document.addEventListener("track_clicked", (event) => {
            window.localStorage.setItem("playing_track_id", event.detail.id);
            _this.player = document.querySelector("#playerBlock");
            _this.player.style.cssText = "";
            _this.mobilePlayer = document.querySelector(".player-mobile");
            const track = _this.tracks.get({ id: event.detail.id });

            if (track !== _this.track) {
                _this.autoload = event.detail.autoload ?? false;
                _this.track = track;
                try {
                    _this.track.setupArtistsObject(_this.artists);
                    _this.trackElement = event.detail.target;
                    if (document.querySelector("#tracksSection .track-item.is-selected")) {
                        document.querySelector("#tracksSection .track-item.is-selected").classList.remove("is-selected");
                    }
                    if (_this.trackElement) {
                        event.detail.target.classList.add("is-selected");
                    }
                    if (event.detail.source === "list") {
                        _this.sendTrackPlayCount(track);
                    }
                    return _this.getFullTrackInfo(event.detail.id);
                } catch (e) {
                    console.log("[PlayerManager - Init] Track " + event.detail.id +" -- Error: " + e);
                    return {};
                }
            }

            const audio = _this.player.querySelector("audio");
            if (audio.paused) {
                _this.emitEvent("track_play");
                _this.setPlay(audio);
            } else {
                _this.emitEvent("track_pause");
                _this.setPause(audio);
            }
        });
        document.addEventListener("video_play", (event) => {
            if (_this.player) {
                const audio = _this.player.querySelector("audio");
                _this.setPlay(audio);
            }
        });
        document.addEventListener("video_pause", (event) => {
            if (_this.player) {
                const audio = _this.player.querySelector("audio");
                _this.setPause(audio);
            }
        });

        document.addEventListener("audio_forward", (event) => {
            if (_this.player) {
                _this.setPlayerTimeDSec(_this.player, +6);
            }
        });
        document.addEventListener("audio_backward", (event) => {
            if (_this.player) {
                _this.setPlayerTimeDSec(_this.player, -6);
            }
        });
        document.addEventListener("audio_next", (event) => {
            if (_this.player) {
                this.setNewTrack("next");   
            }
        });
        document.addEventListener("audio_prev", (event) => {
            if (_this.player) {
                this.setNewTrack("prev");
            }
        });


        /* 221229 - Sticky Header */
        if (document.querySelector(".fm-main-content") && document.querySelector(".szFindMusicPage")) {
            const h = document.querySelector(".szHeader").offsetHeight - 1;
            // console.log(">> " + h);
            if (h > 0) document.querySelector(".fm-main-content").style.cssText += ";margin-top:" + h + "px";
        }
        /* --- */

    }

    getFullTrackInfo(id) {
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Get full Track Info - Fetching");
        const _this = this;
        fetch(`${Globals.WS_URL}?mode=TRACK&track_id=${id}`)
            // fetch(`/apisounzone/gettrack/` + id)
            .then(this.handleResponse)
            .then((result) => {
                if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Get full Track Info - Fetch Data OK");

                _this.track.data.Wave = result.data.tracks[0].Wave;

                this.show();
                this.trackEnded = false;
                if (!this.initialized) {
                    this.setupEvents();
                    this.setupTooltip();
                    this.setupVolume();
                    this.setupDropdown();
                    this.initialized = true;
                }
            })
            .catch((error) => {
                Globals.SHOW_ALL_CONSOLE_LOG && console.log({ message: error.message });
                jQuery(".js-critical-error").show();
            });
    }

    show() {
        this.player.classList.add("active");
        this.player.querySelector(".track-name").textContent = this.track.data.Name;
        if (this.track.data.Artists[0]) {
            this.player.querySelector(".track-artist").href = this.setUrlParams("/artist/" + this._normalizza_track_prop(this.track.data.Artists[0].data.Name), [
                { key: "id", value: this.track.data.Artists[0].data.ID },
                { key: "format", value: this._normalizza_track_prop(this.track.data.Artists[0].data.Format) },
            ]);
            this.player.querySelector(".track-artist").textContent = this.track.data.Artists.map((artist) => artist && artist.data.Name).join(", ");
            // this.player.querySelector(".track-length").textContent = this.track.data.MP3.LengthFMT;
        }

        const _this = this;
        this.drawWave(this.player);

        this.player.querySelector("audio").src = this.track.data.MP3.Url;
        this.player.querySelector(".inside-circle .play-img").style.display = "";
        this.player.querySelector(".inside-circle .pause-img").style.display = "none";
        if (!this.initialized) {
            this.player.querySelector("audio").addEventListener("loadstart", (event) => {
                if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("LOAD START");
                // _this.emitEvent("track_pause");
                // _this.setPause(event.target);
            });
            this.player.querySelector("audio").addEventListener("loadeddata", (event) => {
                if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("LOADED DATA");
                _this.updateTotalLength();
                _this.updateCurrentTime(this.player);
                _this.updateCurrentTime(this.mobilePlayer);
            });
            this.player.querySelector("audio").addEventListener("progress", (event) => {
                if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("PROGRESS");
            });
            this.player.querySelector("audio").addEventListener("canplay", (event) => {
                if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("CAN PLAY");
                if (_this.autoload === false) {
                    _this.emitEvent("track_play");
                    _this.setPlay(event.target);
                }
            });
            this.player.querySelector("audio").addEventListener("canplaythrough", (event) => {
                if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("CAN PLAY THROUGH");
                if (_this.autoload === false) {
                    _this.emitEvent("track_play");
                    _this.setPlay(event.target);
                }
            });
        }
        this.player.querySelector("audio").load();

        this.mobilePlayer.querySelector(".track-item .tl-track").textContent = this.track.data.Name;
        if (this.track.data.Artists[0]) {
            this.mobilePlayer.querySelector(".track-item .tl-artist").href = this.setUrlParams("/artist/" + this._normalizza_track_prop(this.track.data.Artists[0].data.Name), [
                { key: "id", value: this.track.data.Artists[0].data.ID },
                { key: "format", value: this._normalizza_track_prop(this.track.data.Artists[0].data.Format) },
            ]);
            this.mobilePlayer.querySelector(".track-item .tl-artist").innerHTML = this.track.data.Artists.map((artist) => artist && artist.data.Name).join(", ");
        }
        this.mobilePlayer.querySelector(".player-controls-wrapper .inside-circle .play-img").style.display = "";
        this.mobilePlayer.querySelector(".player-controls-wrapper .inside-circle .pause-img").style.display = "none";

        let image = new Image();
        image.alt = this.track.data.Name;
        image.className = "img-fluid";
        const album = this.albums.data.filter((album) => album.data.Tracks.filter((track) => track === this.track.data.ID)[0])[0];
        if (!album && this.track.data.Artists[0]) {
            image.src = this.track.data.Artists[0].data.Image.Medium;
        } else if (album?.data?.Image.Medium) {
            image.src = album.data.Image.Medium;
        } else {
            image = null;
        }
        if (image) {
            this.mobilePlayer.querySelector(".music-item-thumb .wrapper-img").appendChild(image);
        }
    }

    setPlay(audio) {
        if (audio.src) {
            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("PLAY");
            audio.play().catch((error) => Globals.SHOW_ALL_CONSOLE_LOG && console.log("ERROR", error));
            if (!audio.paused) {
                this.startIntervalManager(this);
                this.player.querySelector(".inside-circle .play-img").style.display = "none";
                this.player.querySelector(".inside-circle .pause-img").style.display = "";
                this.mobilePlayer.querySelector(".inside-circle .play-img").style.display = "none";
                this.mobilePlayer.querySelector(".inside-circle .pause-img").style.display = "";
                if (document.querySelector(".tracks-list .track-item.is-playing")) {
                    document.querySelector(".tracks-list .track-item.is-playing").classList.remove("is-playing");
                }
                if (document.querySelector(".tracks-list .track-item.is-selected")) {
                    document.querySelector(".tracks-list .track-item.is-selected").classList.add("is-playing");
                }
            }
        }
    }

    setPause(audio) {
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("PAUSE");
        clearInterval(this.playingInterval);
        audio.pause();
        this.player.querySelector(".inside-circle .play-img").style.display = "";
        this.player.querySelector(".inside-circle .pause-img").style.display = "none";
        this.player.querySelector(".player-controls-wrapper .circle-wrap").classList.remove("is-selected");
        this.mobilePlayer.querySelector(".inside-circle .play-img").style.display = "";
        this.mobilePlayer.querySelector(".inside-circle .pause-img").style.display = "none";
        this.mobilePlayer.querySelector(".player-controls-wrapper .circle-wrap").classList.remove("is-selected");
        if (document.querySelector(".tracks-list .track-item.is-playing")) {
            document.querySelector(".tracks-list .track-item.is-playing").classList.remove("is-playing");
        }
    }

    setupEvents() {
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("PlayerManager - setupEvents");
        const wrapper = this.player.querySelector(".player-controls-wrapper");
        const audio = this.player.querySelector("audio");
        wrapper.querySelector(".prev").addEventListener("click", (event) => {
            this.setNewTrack("prev");
        });
        wrapper.querySelector(".next").addEventListener("click", (event) => {
            this.setNewTrack("next");
        });
        wrapper.querySelector(".play").addEventListener("click", (event) => {
            if (!audio.paused) {
                this.emitEvent("track_pause");
                return this.setPause(audio);
            }
            this.setPlay(audio);
            this.emitEvent("track_play");
        });

        const reduceBtn = this.mobilePlayer.querySelector(".reduce-btn");
        reduceBtn.addEventListener("click", (event) => {
            this.mobilePlayer.classList.toggle("player-mobile--closed");
            setTimeout(() => {
                this.drawWave(this.mobilePlayer);
            }, 200);
        });
        const mobileTrackTitle = this.mobilePlayer.querySelector(".tl-track");
        mobileTrackTitle.addEventListener("click", (event) => {
            this.mobilePlayer.classList.toggle("player-mobile--closed");
            setTimeout(() => {
                this.drawWave(this.mobilePlayer);
            }, 200);
        });
        const mobileTrackArtist = this.mobilePlayer.querySelector(".tl-artist");
        mobileTrackArtist.addEventListener("click", (event) => {
            this.mobilePlayer.classList.toggle("player-mobile--closed");
            setTimeout(() => {
                this.drawWave(this.mobilePlayer);
            }, 200);
        });

        const wrapperMobile = this.mobilePlayer.querySelector(".player-controls-wrapper");
        wrapperMobile.querySelector(".prev").addEventListener("click", (event) => {
            this.setNewTrack("prev");
        });
        wrapperMobile.querySelector(".next").addEventListener("click", (event) => {
            this.setNewTrack("next");
        });
        wrapperMobile.querySelector(".play").addEventListener("click", (event) => {
            if (!audio.paused) {
                this.emitEvent("track_pause");
                return this.setPause(audio);
            }
            this.setPlay(audio);
            this.emitEvent("track_play");
        });

        this.emitEvent("player_ready");
    }

    startIntervalManager(_this) {
        const audio = _this.player.querySelector("audio");
        if (audio.paused) {
            const wrapper = _this.player.querySelector(".player-controls-wrapper");
            wrapper.querySelector(".circle-wrap").classList.add("is-selected");
        }
        _this.updateCurrentTime(_this.player);
        _this.updateCurrentTime(_this.mobilePlayer);
        _this.updateCircleProgress(_this.player);
        _this.updateCircleProgress(_this.mobilePlayer);
        _this.playingInterval = setInterval(() => {
            _this.updateCurrentTime(_this.player);
            _this.updateCurrentTime(_this.mobilePlayer);
            _this.updateCircleProgress(_this.player);
            _this.updateCircleProgress(_this.mobilePlayer);
        }, 1000);
    }

    updateCurrentTime(player) {
        const audio = this.player.querySelector("audio");
        player.querySelector(".player-current-time").textContent = this.formatTime(audio.currentTime);
        if (audio.currentTime === audio.duration) {
            if (!this.trackEnded) {
                this.trackEnded = true;
                clearInterval(this.playingInterval);
                this.setNewTrack("next");
            }
        }
    }

    updateCircleProgress(player) {
        const wrapper = player.querySelector(".player-controls-wrapper");
        const audio = this.player.querySelector("audio");
        const deg = (360 * (audio.currentTime / audio.duration)) / 2;
        wrapper.querySelector(".circle-wrap .circle .mask.full").style.transform = `rotate(${deg}deg)`;
        wrapper.querySelector(".circle-wrap .circle .mask .fill").style.transform = `rotate(${deg}deg)`;
        wrapper.querySelector(".circle-wrap .circle .half .fill").style.transform = `rotate(${deg}deg)`;

        const wave = player.querySelector(".wave");
        const x = (wave.getBoundingClientRect().width * audio.currentTime) / parseInt(audio.duration);
        wave.querySelector(".cont2").style.width = `${x}px`;
    }

    updateTotalLength() {
        const audio = this.player.querySelector("audio");
        this.player.querySelector(".track-length").textContent = this.formatTime(audio.duration);
        this.mobilePlayer.querySelector(".track-length").textContent = this.formatTime(audio.duration);
    }

    setupTooltip() {
        const container = this.player.querySelector(".wave-container");
        const wave = container.querySelector(".wave");
        const tooltip = container.querySelector(".tooltip");
        wave.addEventListener("mousemove", (event) => {
            const { x, y } = this.getMouseCoordinate(event, wave);
            this.setTooltipPosition(x);
        });
        wave.addEventListener("mouseenter", (event) => {
            tooltip.style.opacity = 1;
        });
        wave.addEventListener("mouseleave", (event) => {
            this.setTooltipPosition(0);
            tooltip.style.opacity = 0;
        });
        wave.addEventListener("click", (event) => {
            const { x, y } = this.getMouseCoordinate(event, wave);
            this.setPlayerTime(this.player, x);
        });

        const mobileContainer = this.mobilePlayer.querySelector(".wave-container");
        const mobileWave = mobileContainer.querySelector(".wave");
        const mobileTooltip = mobileContainer.querySelector(".tooltip");
        mobileWave.addEventListener("mousemove", (event) => {
            const { x, y } = this.getMouseCoordinate(event, mobileWave);
            this.setTooltipPosition(x);
        });
        mobileWave.addEventListener("mouseenter", (event) => {
            mobileTooltip.style.opacity = 1;
        });
        mobileWave.addEventListener("mouseleave", (event) => {
            this.setTooltipPosition(0);
            mobileTooltip.style.opacity = 0;
        });
        mobileWave.addEventListener("click", (event) => {
            const { x, y } = this.getMouseCoordinate(event, mobileWave);
            this.setPlayerTime(this.mobilePlayer, x);
        });
    }

    setPlayerTime(player, x) {
        const container = player.querySelector(".wave-container");
        const wave = container.querySelector(".wave");
        const audio = this.player.querySelector("audio");
        const time = (parseInt(audio.duration) * x) / wave.getBoundingClientRect().width;
        audio.currentTime = time;
        if (audio.paused) {
            this.setPlay(audio);
            this.emitEvent("track_play");
        }
    }

    setPlayerTimePerc(player, np) {
        const audio = this.player.querySelector("audio");
        audio.currentTime = audio.duration * np;
        if (audio.paused) {
            this.setPlay(audio);
            this.emitEvent("track_play");
        }
    }

    setPlayerTimeDSec(player, sv) {
        const audio = this.player.querySelector("audio");
        audio.currentTime += sv;
        if (audio.paused) {
            this.setPlay(audio);
            this.emitEvent("track_play");
        }
    }

    setTooltipPosition(x) {
        const container = this.player.querySelector(".wave-container");
        const wave = container.querySelector(".wave");
        const tooltip = container.querySelector(".tooltip");

        const audio = this.player.querySelector("audio");
        const positionTime = (parseInt(audio.duration) * x) / wave.getBoundingClientRect().width;

        const tooltipTime = this.formatTime(positionTime);

        tooltip.style.transform = `translateX(${x}px)`;
        tooltip.querySelector(".time").textContent = tooltipTime;
        wave.querySelector(".cont3").style.width = `${x}px`;

        const mobileContainer = this.mobilePlayer.querySelector(".wave-container");
        const mobileWave = mobileContainer.querySelector(".wave");
        const mobileTooltip = mobileContainer.querySelector(".tooltip");

        const mobilePositionTime = (parseInt(audio.duration) * x) / mobileWave.getBoundingClientRect().width;
        const mobileTooltipTime = this.formatTime(mobilePositionTime);

        mobileTooltip.style.transform = `translateX(${x}px)`;
        mobileTooltip.querySelector(".time").textContent = mobileTooltipTime;
        mobileWave.querySelector(".cont3").style.width = `${x}px`;
    }

    setupVolume() {
        const audio = this.player.querySelector("audio");
        const wrapper = this.player.querySelector(".player-volume-wrapper");
        const volumeContainer = wrapper.querySelector(".volume-bar-container");
        const volumeBar = volumeContainer.querySelector(".volume-bar");
        const volumeLevel = volumeBar.getBoundingClientRect().width / volumeContainer.getBoundingClientRect().width;
        if (volumeLevel > 0) {
            audio.volume = volumeLevel;
        }
        wrapper.addEventListener("click", (event) => {
            this.setVolume(event, volumeContainer, audio);
        });
        wrapper.addEventListener("mousedown", (event) => {
            this.mouseMoving = true;
        });
        wrapper.addEventListener("mouseup", (event) => {
            this.mouseMoving = false;
        });
        wrapper.addEventListener("mouseleave", (event) => {
            this.mouseMoving = false;
        });
        wrapper.addEventListener("mousemove", (event) => {
            if (this.mouseMoving) {
                this.setVolume(event, volumeContainer, audio);
            }
        });
    }

    setVolume(event, volumeContainer, audio) {
        const volumeBar = volumeContainer.querySelector(".volume-bar");
        const { x, y } = this.getMouseCoordinate(event, volumeContainer);
        let volume = x / volumeContainer.getBoundingClientRect().width;
        volumeBar.style.width = `${volume * 100}%`;
        if (volume < 0) volume = 0;
        else if (volume > 1) volume = 1;
        audio.volume = volume;
    }

    setNewTrack(button) {
        if (this.trackElement) {
            const prevTrack = this.trackElement.previousSibling;
            const nextTrack = this.trackElement.nextSibling;
            let target = prevTrack;
            if (button === "next") {
                target = nextTrack;
            }
            if (target) {
                this.trackElement.classList.remove("is-selected");
                this.trackElement.classList.remove("is-playing");
                this.emitEvent("track_clicked", { detail: { id: target.dataset.id, target } });
            }
        }
    }

    setupDropdown() {
        const _this = this;

        this.player.querySelector(".dropdown .dropdown-menu .dropdown-playlist").classList.remove("show");
        this.player.querySelector(".dropdown .icon-plus").addEventListener("click", (event) => {
            this.player.querySelector(".dropdown .dropdown-menu .dropdown-playlist").classList.remove("show");
        });

        // this.player.querySelector(".dropdown .dropdown-menu .add-to-playlist").addEventListener("click", (event) => {
        //     event.preventDefault();
        //     event.stopPropagation();
        //     this.player.querySelector(".dropdown .dropdown-menu .dropdown-playlist").classList.toggle("show");
        // });

        let menuItem = jQuery(this.player.querySelector(".dropdown .dropdown-menu .add-to-playlist"));
        let menuItemToShow = jQuery(this.player.querySelector(".dropdown .dropdown-menu .dropdown-playlist")).show();
        this.menuItemToShowStatus = false;
        menuItemToShow.on("mouseenter", () => {
            this.menuItemToShowStatus = true;
        });
        menuItemToShow.on("mouseleave", () => {
            this.menuItemToShowStatus = false;
            menuItemToShow.hide();
        });
        if (Pqp.isMobile()) {
            menuItem.on("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
                if (menuItemToShow.is(":visible")) {
                    menuItemToShow.hide();
                } else {
                    menuItemToShow.show();
                }
            });
        } else {
            menuItem.on("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
            });
        }
        if (!Pqp.isMobile()) {
            menuItem.on("mouseenter", () => {
                menuItemToShow.show();
            });
            menuItem.on("mouseleave", () => {
                requestAnimationFrame(() => {
                    if (!this.menuItemToShowStatus) {
                        menuItemToShow.hide();
                    }
                });
            });
        }
        menuItemToShow.hide();

        this.player.querySelector(".dropdown .dropdown-submenu .create-link").addEventListener("click", (event) => {
            event.preventDefault();
            if (_this.userManager.userLogged) {
                jQuery("#playlistModal").modal("show");
                document.querySelector("#playlistModal input[name=plTrackId]").value = _this.track.data.ID;
            } else {
                jQuery("#notLoggedModal").modal("show");
            }
        });

        this.player.querySelector(".dropdown .dropdown-menu .licenses-add").addEventListener("click", (event) => {
            event.preventDefault();
            _this.emitEvent("add_track_to_licenses", { detail: { track: _this.track.data } });
        });

        this.player.querySelector(".dropdown .dropdown-menu .download").addEventListener("click", (event) => {
            event.preventDefault();
            if (_this.userManager.userLogged) {
                _this.requestDownload(_this.userManager, _this.track.data);
            } else {
                // jQuery("#notLoggedModal").modal("show");
                window.location.href = "/pricing";
            }
        });

        this.player.querySelector(".dropdown .dropdown-menu .match-video").addEventListener("click", (event) => {
            event.preventDefault();
            _this.emitEvent("match_video_to_track", { detail: { track: _this.track.data } });
            // if (_this.userManager.userLogged) {
            //     _this.emitEvent("match_video_to_track", { detail: { track: _this.track.data } });
            // } else {
            //     jQuery("#notLoggedModal").modal("show");
            // }
        });

        this.mobilePlayer.querySelector(".dropdown .dropdown-menu .dropdown-playlist").classList.remove("show");
        this.mobilePlayer.querySelector(".dropdown .icon-plus").addEventListener("click", (event) => {
            this.mobilePlayer.querySelector(".dropdown .dropdown-menu .dropdown-playlist").classList.remove("show");
        });

        this.mobilePlayer.querySelector(".dropdown .dropdown-menu .add-to-playlist").addEventListener("click", (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.mobilePlayer.querySelector(".dropdown .dropdown-menu .dropdown-playlist").classList.toggle("show");
        });

        this.mobilePlayer.querySelector(".dropdown .dropdown-submenu .create-link").addEventListener("click", (event) => {
            event.preventDefault();
            if (_this.userManager.userLogged) {
                jQuery("#playlistModal").modal("show");
                document.querySelector("#playlistModal input[name=plTrackId]").value = _this.track.data.ID;
            } else {
                jQuery("#notLoggedModal").modal("show");
            }
        });

        this.mobilePlayer.querySelector(".dropdown .dropdown-menu .licenses-add").addEventListener("click", (event) => {
            event.preventDefault();
            _this.emitEvent("add_track_to_licenses", { detail: { track: _this.track.data } });
        });

        this.mobilePlayer.querySelector(".dropdown .dropdown-menu .download").addEventListener("click", (event) => {
            event.preventDefault();
            if (_this.userManager.userLogged) {
                _this.requestDownload(_this.userManager, _this.track.data);
            } else {
                // jQuery("#notLoggedModal").modal("show");
                window.location.href = "/pricing";
            }
        });

        this.mobilePlayer.querySelector(".dropdown .dropdown-menu .match-video").addEventListener("click", (event) => {
            event.preventDefault();
            window.location.href = "/match-video-mobile";
        });

        this.updateDropdown();
    }

    updateDropdown() {
        const _this = this;
        if (this.player && this.mobilePlayer) {
            let list = this.player.querySelector(".dropdown .dropdown-myplaylists");
            list.textContent = "";
            let mobileList = this.mobilePlayer.querySelector(".dropdown .dropdown-myplaylists");
            mobileList.textContent = "";
            if (this.userManager.userPlaylists.length > 0) {
                const userPlaylists = this.playlists.getAddTrackMyPlaylistList(this.userManager);
                userPlaylists.map((playlist) => {
                    const item = playlist.cloneNode(true);
                    const button = item.querySelector("a");
                    button.addEventListener("click", (event) => {
                        this.playlists.addTrackToPlaylist(event.currentTarget.dataset.id, this.track.data);
                    });
                    list.appendChild(item);
                    mobileList.appendChild(item.cloneNode(true));
                });
                const found = this.userManager.userPlaylists.filter((playlist) => playlist.Tracks.indexOf(this.track.data.ID) > -1);
                if (found.length === 0) {
                    this.player.querySelectorAll(".remove-playlist").forEach((el) => (el.style.display = "none"));
                    this.mobilePlayer.querySelectorAll(".remove-playlist").forEach((el) => (el.style.display = "none"));
                } else {
                    if (this.player.querySelector(".remove-playlist .remove-link")) {
                        this.player.querySelector(".remove-playlist .remove-link").addEventListener("click", (event) => {
                            _this.playlists.showRemoveTrackDialog(_this.track.data.ID, found[0]);
                        });
                    }
                    if (this.mobilePlayer.querySelector(".remove-playlist .remove-link")) {
                        this.mobilePlayer.querySelector(".remove-playlist .remove-link").addEventListener("click", (event) => {
                            _this.playlists.showRemoveTrackDialog(_this.track.data.ID, found[0]);
                        });
                    }
                }
            } else {
                this.player.querySelectorAll(".remove-playlist").forEach((el) => (el.style.display = "none"));
                this.mobilePlayer.querySelectorAll(".remove-playlist").forEach((el) => (el.style.display = "none"));
            }
        }
    }

    drawWave(player) {
        var waveWidth = 1024;
        var waveHeight = 64;
        var waveBarW = 1;
        var waveMaxBars = Math.round(waveWidth / waveBarW);
        var waveA = new Array();

        const decodedWave = atob(this.track.data.Wave);

        for (let k = 0; k < decodedWave.length; k++) {
            waveA.push(decodedWave.charCodeAt(k));
        }

        let colw = player.querySelector(".wave").getBoundingClientRect().width;

        var waveCurBars = Math.floor(colw / waveBarW);
        if (waveCurBars > waveWidth) {
            waveCurBars = waveWidth;
        }

        var wbit = Math.floor(waveWidth / waveCurBars);
        player.querySelector(".wave").setAttribute("wbit", wbit);

        var canvas = document.getElementById("waveCanvas");
        var cw = (canvas.width = player.querySelector(".wave").getBoundingClientRect().width);
        var ch = (canvas.height = 64);

        var ctx = canvas.getContext("2d");

        var contStyleA = ["", "rgb(254,195,196)", "rgb(253,132,136)", "rgb(253,76,87)"];

        var a = 0.9;
        var contStyleB = ["", "rgba(254,195,196," + a + ")", "rgba(253,132,136," + a + ")", "rgba(253,76,87," + a + ")"];

        for (var ck = 1; ck < 4; ck++) {
            ctx.fillStyle = "rgba(0,0,0,0)";
            ctx.fillRect(0, 0, cw, ch);

            ctx.fillStyle = contStyleA[ck];

            for (let k = 0; k < colw; k++) {
                ctx.fillStyle = k % 4 == 3 ? contStyleB[ck] : contStyleA[ck];

                let t;
                // Average
                let v = 0;
                for (let q = 0; q < wbit; q++) {
                    t = Math.floor((waveWidth * k) / colw);
                    t = t < 0 ? 0 : t >= waveA.length ? waveA.length - 1 : t;
                    v += waveA[t];
                }
                v = v / wbit;
                // Max
                let e = 0;
                for (let q = 0; q < wbit; q++) {
                    t = Math.floor((waveWidth * k) / colw);
                    t = t < 0 ? 0 : t >= waveA.length ? waveA.length - 1 : t;
                    if (waveA[t] > e) e = waveA[t];
                }

                t = (v + e) / 2;

                v = waveHeight - v / 2;
                // ---
                if (waveBarW == 1) {
                    ctx.fillRect(k * waveBarW, v, 1, waveHeight - v + waveBarW * 2);
                } else {
                    ctx.roundRect(k * waveBarW, v, waveBarW - 1, waveHeight - v + waveBarW * 2, 1.5).fill();
                }
            }

            var dataUrl = canvas.toDataURL();
            player.querySelector(".wave .cont" + ck).style.backgroundImage = "url(" + dataUrl + ")";
            if (ck !== 1) {
                player.querySelector(".wave .cont" + ck).style.width = "0px";
            }
        }

        ctx.clearRect(0, 0, canvas.width, canvas.height);
    }

    sendTrackPlayCount(track) {
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("PlayerManager - Sending Track play count");
        const token = this.getCookie("user_token");
        fetch(`${Globals.WS_URL}?mode=TRACK.PLAY&token=${token}&track_id=${track.data.ID}`)
            .then(this.handleResponse)
            .then((result) => {
                if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("PlayerManager - Track play count OK");
                if (Globals.SHOW_ALL_CONSOLE_LOG) console.log(result);
            })
            .catch((error) => {
                Globals.SHOW_ALL_CONSOLE_LOG && console.log({ message: error.message });
                jQuery(".js-critical-error").show();
            });
    }
}
